<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1">
          <h6>{{ $t('Advanced search') }}</h6>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">ชื่อศูนย์</div>
          <input type="text" v-model="filter.branch_name" />
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">Username</div>
          <input type="text" v-model="filter.admin_id" />
        </v-flex>
        <!-- <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">Role</div>
          <input type="text" v-model="filter.role" />
        </v-flex> -->
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">Role</div>
          <multiselect
            v-model="filter.role"
            :options="roleList"
            label="label"
            selectLabel
            selectedLabel
            track-by="value"
            :openDirection="'above'"
          ></multiselect>
        </v-flex>
      </v-layout>
      <v-layout wrap class="form-control">
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn @click="clearSearch" color="grey" outline>{{ $t('Clear Search') }}</v-btn>
            <v-btn @click="onSearch" color="primary">{{ $t('Search') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const initialFilter = {
  branch_name: '',
  admin_id: '',
  role: ''
}
export default {
  components: { Multiselect },
  data() {
    return {
      filter: { ...initialFilter },
      roleList: [
        {
          label: 'พนักงานอนุมัติ',
          value: 'approver'
        },
        {
          label: 'หัวหน้าศูนย์',
          value: 'supervisor'
        },
        {
          label: 'Super Admin',
          value: 'superadmin'
        }
      ]
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      const filter = {
        ...this.filter,
        role: this.filter.role && this.filter.role.value ? this.filter.role.value : null
      }
      this.$emit('onSearch', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.caption {
  font-size: 14px !important;
  margin-bottom: 12px;
}
input {
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/SearchAdminDialog.vue